import styled from '@emotion/styled'
import { Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { keyframes } from '@emotion/css'

const blinkAnimation = keyframes`
  0% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.3; transform: scale(1.15); }
  100% { opacity: 1; transform: scale(1); }
`

export const BlinkingWrapper = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ef2605;
  animation: ${blinkAnimation} 1.2s infinite ease-in-out;
`

export const CardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  padding: 32px;
  width: 100%;
  position: relative;
  user-select: none;
`

export const BoxSearch = styled('div')`
  flex: 0 0 50%;
`

export const SearchInput = styled(Input)`
  min-width: 450px;
  max-width: 450px;
  height: 40px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
`

export const SearchIcon = styled(SearchOutlined)`
  color: #adadad;
`

export const HeaderWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

export const Dot = styled('div')<{ color: string }>`
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: ${(props) => props.color};
`

export const TableContainer = styled('div')`
  width: 100%;
  .ant-table-thead > tr > th {
    background: #fbfbfb !important;
    color: #666 !important;
    font-family: 'Prompt', sans-serif !important;
    font-weight: 500 !important;
    font-size: 12px !important;
    line-height: 16px !important;
    text-transform: uppercase !important;
    letter-spacing: -0.4px !important;
  }
  .ant-table-tbody > tr.selected-row > td {
    background: #e6f6ea !important;
  }
  cursor: pointer;
`

export const ButtonIcon = styled('img')`
  cursor: pointer;
  width: 20px;
  height: 20px;
`

export const EmptySpaceIcon = styled('div')`
  width: 20px;
  height: 20px;
`
